import TYPES from '../action-types';
import patchAssetInAllPools from './helpers/patchAssetInAllPools';

export const reducer = (builder) => {
  builder.addCase(TYPES.ASSETS.SET_ALT_TEXT.COMPLETE, (state, { payload }) => {
    if (!payload?.assetId) return;
    patchAssetInAllPools(state, {
      _id: payload.assetId,
      altText: payload.altText ?? '',
    });
  });
};
